module.exports = __webpack_public_path__ + "static/img/ico_play.e554f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_play.png
// module id = EgjX
// module chunks = 1